exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ipt-text[data-v-0478220c]{text-align:right;display:block;width:100%;border:0}.ipt-text[data-v-0478220c]::-webkit-input-placeholder{color:#999}", ""]);

// exports
